// apps/web/src/services/UploadService.js

import { api } from './api'

const UploadService = {
  image(file) {
    const formData = new FormData()

    formData.append('file', file)

    return api.post(
      '/uploads/image',
      formData,
      {
        headers: {
          'Content-Type':
            'multipart/form-data',
        },
      },
    )
  },

  video(file) {
    const formData = new FormData()

    formData.append('file', file)

    return api.post(
      '/uploads/video',
      formData,
      {
        headers: {
          'Content-Type':
            'multipart/form-data',
        },
      },
    )
  },

  audio(file) {
    const formData = new FormData()

    formData.append('file', file)

    return api.post(
      '/uploads/audio',
      formData,
      {
        headers: {
          'Content-Type':
            'multipart/form-data',
        },
      },
    )
  },
}

export default UploadService